import React from 'react'
import * as Types from '../../../declarations'
import SinglePicDesign from './SinglePicDesign'
import MultiPicDesign from './MultiPicDesign'
import { useIsMobile } from '../../../lib/useIsMobile'
import { getTrekImageAltText } from '../../../lib/display'
import PictureUploadButton from '../components/PictureUploadButton'

interface Props {
	trip: Types.DB.Models.TripAttributes
	onImageClick: (imageId: number) => void
}

const TopImageGallery = ({
	trip: { uploads: allImages, slug },
	trip: trek,
	onImageClick,
}: Props) => {
	const images = allImages?.filter(
		({ isDisplayedInGallery }) => !!isDisplayedInGallery,
	)
	if (!images) return <></>

	const [isHydrated, setIsHydrated] = React.useState(false)

	React.useEffect(() => {
		setIsHydrated(true)
	}, [])

	const isMobile = useIsMobile()

	const isSinglePicDesign = images.length < 5 || (isHydrated && isMobile)

	const altText = getTrekImageAltText(trek)

	return (
		<>
			<div
				id="top-image-gallery-wrapper"
				className="spacing-between-sections-above"
			>
				{isSinglePicDesign && (
					<SinglePicDesign
						image={images[0]}
						slug={slug}
						onImageClick={onImageClick}
						altText={altText}
					/>
				)}
				{!isSinglePicDesign && (
					<MultiPicDesign
						images={images}
						slug={slug}
						onImageClick={onImageClick}
						altText={altText}
					/>
				)}
			</div>
			<div id="trip-page-picture-upload-button">
				<PictureUploadButton />
			</div>
		</>
	)
}

export default TopImageGallery
